var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex overflow-auto"},[_c('div',{staticClass:"fences-grid",style:({
      'grid-template-rows': `repeat(${_vm.rows}, ${_vm.cellSize}px)`,
      'grid-template-columns': `repeat(${_vm.columns}, ${_vm.cellSize}px)`,
    })},_vm._l((_vm.table),function(cell){return _c('fences-cell',{key:`${cell.positiony}-${cell.positionx}`,attrs:{"cell":cell,"cell-size":_vm.cellSize,"settings":_vm.settings}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }